<template>
  <sui-modal :open="isOpen" scrolling>
    <sui-modal-content>
      <div class="wrapper">
        <div id="fattura" v-if="isOpen" class="fattura">
          <!-- TESTATA -->
          <div class="header">
            <div class="timbro">
              <img src="/timbro.png" />
              <div class="riferimenti">
                <h1>Alessandro Timineri</h1>
                <span><b>Operatore Olistico Professionale</b></span>
                <span>Via Boselli 1/4 (SV)</span>
                <span><b>Telefono +39 348 733 0167</b></span>
                <span>C.F. TMNLSN81B09I480T</span>
                <span>P.IVA 01793960095</span>
              </div>
            </div>
            <div class="testa">
              <div class="numero">
                <span>FATTURA n.</span>
                <div class="input">
                  <input class="line" />
                </div>
              </div>
              <div class="ordine">
                <div class="ordine_modo">
                  <span>a saldo</span>
                  <span>in conto</span>
                </div>
                <span>vs. ordine</span>
                <div class="input">
                  <input class="line" />
                </div>
              </div>
              <div class="data">
                <span>lì</span>
                <div class="data_exploded">
                  <div class="ruler">
                    <input :value="dd(0)" class="line" maxlength="1" />
                  </div>
                  <div class="ruler big">
                    <input :value="dd(1)" class="line" maxlength="1" />
                  </div>
                  <div class="ruler">
                    <input :value="dd(2)" class="line" maxlength="1" />
                  </div>
                  <div class="ruler big">
                    <input :value="dd(3)" class="line" maxlength="1" />
                  </div>
                  <div class="ruler">
                    <input :value="dd(4)" class="line" maxlength="1" />
                  </div>
                  <div class="ruler">
                    <input :value="dd(5)" class="line" maxlength="1" />
                  </div>
                  <div class="ruler">
                    <input :value="dd(6)" class="line" maxlength="1" />
                  </div>
                  <div class="ruler">
                    <input :value="dd(7)" class="line" maxlength="1" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- INTESTAZIONE -->
          <div class="intestazione">
            <div class="row">
              <div class="field">
                <label>RIFERIMENTI</label>
                <input class="line" />
              </div>
              <div class="sep">
                <span>S</span>
              </div>
              <div class="field">
                <input :value="form.visualizza_come" class="line" />
              </div>
            </div>
            <div class="row">
              <div class="field">
                <label>CONSEGNA</label>
                <input class="line" />
              </div>
              <div class="sep"></div>
              <div class="field">
                <input :value="form.via_residenza" class="line" />
              </div>
            </div>
            <div class="row">
              <div class="field">
                <label>PARTITA IVA CLIENTE</label>
                <div class="data_exploded piva">
                  <div class="ruler">
                    <input class="line" maxlength="1" />
                  </div>
                  <div class="ruler">
                    <input class="line" maxlength="1" />
                  </div>
                  <div class="ruler">
                    <input class="line" maxlength="1" />
                  </div>
                  <div class="ruler">
                    <input class="line" maxlength="1" />
                  </div>
                  <div class="ruler">
                    <input class="line" maxlength="1" />
                  </div>
                  <div class="ruler">
                    <input class="line" maxlength="1" />
                  </div>
                  <div class="ruler">
                    <input class="line" maxlength="1" />
                  </div>
                  <div class="ruler">
                    <input class="line" maxlength="1" />
                  </div>
                  <div class="ruler">
                    <input class="line" maxlength="1" />
                  </div>
                  <div class="ruler">
                    <input class="line" maxlength="1" />
                  </div>
                  <div class="ruler">
                    <input class="line" maxlength="1" />
                  </div>
                </div>
              </div>
              <div class="sep"></div>
              <div class="field">
                <input
                  :value="
                    `${form.cap_residenza} ${form.comune_residenza} (${form.prov_residenza})`
                  "
                  class="line"
                />
              </div>
            </div>
            <div class="row cf">
              <div class="field">
                <label>CODICE FISCALE CLIENTE</label>
                <div class="data_exploded cf">
                  <div class="ruler">
                    <input :value="cf(0)" class="line" maxlength="1" />
                  </div>
                  <div class="ruler">
                    <input :value="cf(1)" class="line" maxlength="1" />
                  </div>
                  <div class="ruler big">
                    <input :value="cf(2)" class="line" maxlength="1" />
                  </div>
                  <div class="ruler">
                    <input :value="cf(3)" class="line" maxlength="1" />
                  </div>
                  <div class="ruler">
                    <input :value="cf(4)" class="line" maxlength="1" />
                  </div>
                  <div class="ruler big">
                    <input :value="cf(5)" class="line" maxlength="1" />
                  </div>
                  <div class="ruler">
                    <input :value="cf(6)" class="line" maxlength="1" />
                  </div>
                  <div class="ruler">
                    <input :value="cf(7)" class="line" maxlength="1" />
                  </div>
                  <div class="ruler">
                    <input :value="cf(8)" class="line" maxlength="1" />
                  </div>
                  <div class="ruler">
                    <input :value="cf(9)" class="line" maxlength="1" />
                  </div>
                  <div class="ruler big">
                    <input :value="cf(10)" class="line" maxlength="1" />
                  </div>
                  <div class="ruler">
                    <input :value="cf(11)" class="line" maxlength="1" />
                  </div>
                  <div class="ruler">
                    <input :value="cf(12)" class="line" maxlength="1" />
                  </div>
                  <div class="ruler">
                    <input :value="cf(13)" class="line" maxlength="1" />
                  </div>
                  <div class="ruler">
                    <input :value="cf(14)" class="line" maxlength="1" />
                  </div>
                  <div class="ruler">
                    <input :value="cf(15)" class="line" maxlength="1" />
                  </div>
                </div>
              </div>
              <div class="sep"></div>
              <div class="field">
                <input class="line" />
              </div>
            </div>
          </div>
          <!-- PRESTAZIONI -->
          <div class="prestazioni">
            <table>
              <colgroup>
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
              </colgroup>
              <thead>
                <tr>
                  <th>quantità</th>
                  <th>articolo</th>
                  <th>descrizione</th>
                  <th>prezzo</th>
                  <th>sc.</th>
                  <th>importo</th>
                </tr>
              </thead>
              <tbody class="articoli">
                <tr v-for="r in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]" :key="r">
                  <td
                    v-for="c in [
                      'qta',
                      'articolo',
                      'desc',
                      'prezzo',
                      'sc',
                      'importo'
                    ]"
                    :key="c"
                    :class="c"
                  >
                    <input :value="r == 0 && c == 'qta' ? '1' : null" />
                  </td>
                </tr>
              </tbody>
              <tbody class="fondo">
                <tr>
                  <td class="f1" colspan="3" rowspan="2">
                    <div>
                      <span>PAGAMENTI</span>
                      <input class="line" />
                      <input class="line" />
                    </div>
                  </td>
                  <td class="f2" colspan="2"><span>TOTALE</span></td>
                  <td class="importo">
                    <input class="line" />
                  </td>
                </tr>
                <tr>
                  <td class="f3" colspan="2">
                    <div>
                      <span>Bollo<br />o iva</span>
                      <input class="line" />
                      <span>%</span>
                    </div>
                  </td>
                  <td class="importo">
                    <input class="line" />
                  </td>
                </tr>
                <tr>
                  <td colspan="3" rowspan="4" class="bollo">
                    <div>
                      <span>MARCA DA BOLLO</span>
                      "Imposta di bollo assolta sull'originale<br />
                      per importi maggiori di € 77,47"
                    </div>
                    <img src="/firma.png" />
                  </td>
                  <td colspan="2">
                    <input class="line" />
                  </td>
                  <td class="importo">
                    <input class="line" />
                  </td>
                </tr>
                <tr>
                  <td colspan="2"></td>
                  <td class="importo">
                    <input class="line" />
                  </td>
                </tr>
                <tr>
                  <td class="f2" colspan="2"><span>da Pagare €</span></td>
                  <td class="importo pagare">
                    <input class="line" />
                  </td>
                </tr>
                <tr>
                  <td colspan="3" class="operazione">
                    <div>
                      "Operazione effettuata ai sensi dell'art. 1, commi da 54 a
                      89, della Legge n. 190/2014, e articolo 1, commi da 111 a
                      113, della Legge n. 208/2015, e s.m. - Regime
                      forfettario"<br />FINANZIARIA 2019
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </sui-modal-content>
    <sui-modal-actions>
      <sui-button @click.native="$emit('close')">
        Chiudi
      </sui-button>
      <sui-button @click.native="handleEmitFattura" primary>
        Stampa
      </sui-button>
    </sui-modal-actions>
  </sui-modal>
</template>

<script>
import { exportFattura } from '@/services/fattura'
export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      isOpen: this.open
    }
  },
  watch: {
    // eslint-disable-next-line object-shorthand
    open: function(n) {
      this.isOpen = n
    }
  },
  methods: {
    handleEmitFattura() {
      exportFattura(document.getElementById('fattura'))
      // this.$emit('close')
    },
    dd(index) {
      const dd = this.$dayjs().format('DDMMYYYY')
      return dd[index]
    },
    cf(index) {
      if (!this.form.codice_fiscale) return ''
      return this.form.codice_fiscale[index]
    }
  }
}
</script>
<style scoped>
.wrapper {
  --color: #374a7b;
  --width: 600px;
  --height: calc(var(--width) * 1.43);

  font-family: 'Open Sans Condensed';
  color: var(--color);
  height: 70vh;
  overflow-y: auto;
  font-weight: 700;
}
input {
  border: 0px none;
  background: transparent;
  outline: none;
  font-family: 'Roboto Mono';
  font-weight: 500;
  width: 100%;
  transition: 0.5s background;
}
input:focus {
  background: #374a7b49;
}
input.line {
  border-bottom: 1px solid var(--color);
}
.ui.table tr td {
  border-top: 0px none;
}
.ui.basic.table tbody tr {
  border-bottom: 0;
}
.ruler {
  position: relative;
  float: left;
  height: 100%;
  border-right: 1px solid var(--color);
}
.ruler:last-child {
  border-right: 0px none;
}
.ruler input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.ruler.big {
  border-width: 2px;
}
.data_exploded {
  border-left: 1px solid var(--color);
  border-right: 1px solid var(--color);
}
/*----*/
.wrapper * {
  box-sizing: border-box;
}
.fattura {
  margin: 0 auto;
  width: var(--width);
  height: var(--height);
}
.header {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  border-top: 2px solid var(--color);
  border-bottom: 2px solid var(--color);
}
.timbro {
  height: calc(var(--height) * 0.1339);
  width: calc(var(--width) * 0.59);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-family: 'Times New Roman', Times, serif !important;
  text-align: center;
  color: black;
}
.timbro h1 {
  font-family: 'Times New Roman', Times, serif !important;
  text-align: center;
  margin: 0;
  padding: 0;
  font-size: calc(var(--height) * 0.023);
  letter-spacing: calc(var(--width) * 0.004);
}
.timbro span {
  font-size: calc(var(--height) * 0.017);
  line-height: calc(var(--height) * 0.02);
  display: block;
  font-weight: 400;
}
.timbro img {
  width: calc(var(--width) * 0.1329);
  height: calc(var(--height) * 0.0692);
}
.testa {
  width: calc(var(--width) * 0.41);
  border-left: 2px solid var(--color);
  height: calc(var(--height) * 0.1339);
  padding-top: calc(var(--height) * 0.017);
  padding-left: calc(var(--width) * 0.022);
  overflow: hidden;
}
.numero {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.numero span {
  font-size: calc(var(--height) * 0.027);
  letter-spacing: 1px;
  flex-shrink: 0;
}
.numero div.input {
  margin-left: calc(var(--width) * 0.01);
}
.numero input {
  height: calc(var(--height) * 0.028);
  font-size: calc(var(--height) * 0.022);
  text-align: center;
}
.ordine {
  display: flex;
  flex-direction: row;
  font-style: italic;
  align-items: center;
  margin-top: calc(var(--height) * 0.01);
}
.ordine_modo {
  flex-shrink: 0;
}
.ordine_modo span {
  display: block;
  padding: calc(var(--height) * 0.002) 0;
  text-align: center;
  line-height: 100%;
  width: calc(var(--width) * 0.09);
}
.ordine_modo span:first-child {
  border-bottom: 1px solid var(--color);
}
.ordine > span {
  display: block;
  flex-shrink: 0;
  width: calc(var(--width) * 0.09);
  margin-left: calc(var(--width) * 0.01);
}
.ordine div.input {
  margin-left: calc(var(--width) * 0.005);
  margin-top: calc(var(--height) * -0.02);
}
.ordine input {
  text-align: center;
  font-size: calc(var(--height) * 0.018);
  height: calc(var(--height) * 0.028);
}
.data {
  display: flex;
  flex-direction: row;
}
.data span {
  display: block;
  font-style: italic;
}
.data .data_exploded {
  flex-grow: 1;
  margin-top: calc(var(--width) * 0.003);
  margin-left: calc(var(--width) * 0.012);
  height: calc(var(--height) * 0.022);
}
.data_exploded .ruler {
  width: calc(100% / 8);
}
.data_exploded .ruler input {
  text-align: center;
}
/* INTESTAZIONE */
.row {
  display: flex;
  flex-direction: row;
  height: calc(var(--height) * 0.034);
}
.field {
  height: 100%;
  position: relative;
}
.field input {
  position: absolute;
  left: 0;
  top: auto;
  width: 100%;
  bottom: 0;
  height: 80%;
}
.field label {
  position: absolute;
  top: 0;
  left: 0;
  font-size: calc(var(--height) * 0.009);
}
.field .data_exploded {
  position: absolute;
  left: 0;
  width: 100%;
  bottom: 0;
  height: 60%;
}
.field .data_exploded input {
  height: 100%;
}
.field .data_exploded.piva .ruler {
  position: relative;
  width: calc(100% / 11);
}
.intestazione .row .field:first-child {
  width: calc(var(--width) * 0.4);
}
.intestazione .row .field:last-child {
  width: calc(var(--width) * 0.53);
}
.intestazione .row .sep {
  position: relative;
  width: calc(var(--width) * 0.07);
}
.intestazione .row .sep span {
  position: absolute;
  top: calc(var(--height) * 0.009);
  right: calc(var(--width) * 0.02);
  font-size: calc(var(--height) * 0.025);
}
.intestazione .row.cf .field:first-child {
  width: calc(var(--width) * 0.58);
}
.intestazione .row.cf .field:last-child {
  width: calc(var(--width) * 0.35);
}
.field .data_exploded.cf .ruler {
  position: relative;
  width: calc(100% / 16);
}
/* PRESTAZIONI */
.prestazioni {
  margin-top: calc(var(--height) * 0.006);
}
.prestazioni table {
  width: 100%;
  border-spacing: 0px;
  table-layout: fixed;
  border-bottom: 2px solid var(--color);
}
.prestazioni colgroup col:nth-child(1),
.prestazioni colgroup col:nth-child(2) {
  width: calc(var(--width) * 0.1);
}
.prestazioni colgroup col:nth-child(3) {
  width: calc(var(--width) * 0.44);
}
.prestazioni colgroup col:nth-child(4) {
  width: calc(var(--width) * 0.12);
}
.prestazioni colgroup col:nth-child(5) {
  width: calc(var(--width) * 0.05);
}
.prestazioni thead th {
  color: #fff;
  text-align: center;
  text-transform: uppercase;
  font-size: calc(var(--height) * 0.01);
  background: var(--color) !important;
  border-radius: 0 !important;
  padding: 2px 0 !important;
}
.prestazioni tbody td {
  position: relative;
  border-left: 1px solid var(--color);
}
.prestazioni tbody td.qta input,
.prestazioni tbody td.articolo input {
  text-align: center;
}
.prestazioni tbody td.prezzo input,
.prestazioni tbody td.importo input {
  text-align: right;
}
td.importo input {
  font-size: calc(var(--height) * 0.023);
}
.prestazioni tbody td.prezzo,
.prestazioni tbody td.importo {
  background: linear-gradient(
    90deg,
    transparent 0%,
    transparent 66%,
    #eee 67%,
    #eee 100%
  );
}

.prestazioni tbody.articoli td {
  padding: 0;
  border-bottom: 1px solid var(--color);
  height: calc(var(--height) * 0.041);
}
.prestazioni tbody input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 0 calc(var(--width) * 0.01);
}
/* FONDO */
.fondo td {
  height: calc(var(--height) * 0.042);
  padding: 4px;
}
.fondo .f2 {
  position: relative;
}
.fondo .f2:nth-child(1) {
  border-bottom: 1px solid var(--color) !important;
}
.fondo .f2 span {
  position: absolute;
  bottom: 2px;
  right: 4px;
}
.fondo .f3 {
  vertical-align: bottom;
}
.fondo .f1 div,
.fondo .f3 div {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}
.fondo .f1 div span,
.fondo .f3 div span {
  text-align: right;
  line-height: 90%;
  font-size: calc(var(--height) * 0.014);
  padding-left: 3px;
}
.fondo .f1 div input,
.fondo .f3 div input {
  flex-grow: 1;
  margin: 0 3px;
  position: static;
}
.f1,
.bollo,
.operazione {
  border-left: 0px none !important;
}
.operazione {
  border-top: 1px solid var(--color);
}
.pagare {
  border-right: 2px solid var(--color) !important;
  border-top: 1px solid var(--color) !important;
  border-bottom: 1px solid var(--color) !important;
  border-left: 2px solid var(--color) !important;
}
.bollo {
  position: relative;
  padding-left: 0 !important;
  height: calc(var(--height) * 0.21) !important;
  font-size: calc(var(--height) * 0.012);
  line-height: 95%;
}
.bollo > div {
  text-align: center;
  padding-top: calc(var(--height) * 0.08);
  border: 1px solid var(--color);
  height: 100%;
  width: calc(var(--width) * 0.43);
}
.bollo span {
  display: block;
  padding-bottom: calc(var(--height) * 0.012);
  font-size: calc(var(--height) * 0.02);
}
.bollo img {
  position: absolute;
  top: 0;
  left: 0;
}
.operazione {
  position: relative;
  height: calc(var(--height) * 0.07) !important;
}
.operazione div {
  text-align: center;
  position: absolute;
  top: calc(var(--height) * 0.01);
  padding: 0 calc(var(--width) * 0.02);
  right: 0;
  bottom: 0;
  left: calc(var(--width) * -0.2);
  font-size: calc(var(--height) * 0.015);
  line-height: 100%;
}
</style>
